import React from 'react';
const TrackingContext = React.createContext();
export default TrackingContext;